import React from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import DropDownOA from '../../../../common/dropDownOA'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { useState } from 'react'
import GSTStatusModal from './GSTStatusModal'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import { useEffect } from 'react'
import { focusElemnt, getFloat, navigation3 } from '../../../../common/helper'
import ModalHeader from './ModalHeader'
import { AmtAndPerOpt, BranchBusObject, BranchCommissionAgentList, BranchCommissionList, CreditLimitOpt, CreditLimitTypeOpt, GstModalObject, PhoneBookRupeesList, ServiceChargeList, otherCommissionList } from '../BrnchMasterConstant'
import LineinputV2 from '../../../../common/lineinputV2'

import ConfirmModal from './ConfirmModal'
import { connect } from 'react-redux'
import { getBranchData, getGSTNValidation, updateBranchBusData, getBranchMaster } from '../../../../../store/branchAndUserMaster/BUMAction'
import * as mdt from '../../../../common/modaltypes'

const BrnhBusConfig = (props) => {
    const { data: { common, branchAndUserMasterReducer }, getBranchData, updateBranchBusData, getGSTNValidation, setSelectedTab, tabData, confModal, setConfModal, updateModal, getBranchMaster, branchBusValue, setBranchBusValue,
        isDisableBtn, setIsDisableBtn, resetAllValueBrnhMaster, brnhBusGST, setBrnhBusGST,setTabData,loginData } = props
    const { ModalHeaderDropDownData } = branchAndUserMasterReducer
    const [isChecked, setIsChecked] = useState({
        creditLimit: false,
        PhoneBookRupees: true,
    })
    const [resetFlag, setResetFlag] = useState(false)
    const [gstStatusModal, setGstStatusModal] = useState(false)
    const [gstStatusModalProps, setGstStatusModalProps] = useState({})
    const [successAndError, setSuccessAndError] = useState({
        isOpen: false,
        id: 0,
        title: '',
        focusId: "",
        openNextTab: false
    })
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: "24px"
    }
    const showGstStatusModal = (value, ismodalOpen = false) => {
        const body = {
            GSTN: value
        }
        getGSTNValidation(body).then((res) => {
            if (res.status === 'True') {
                let data = {
                    updateModal: setGstStatusModal,
                    headText: "GSTIN Status",
                    gstData: { ...res.Data[0], GSTIN: value }
                }
                setGstStatusModalProps(data)
                setBrnhBusGST({ ...res.Data[0], GSTIN: value, errorModal: false })
                if (ismodalOpen) {
                    setGstStatusModal(true)
                }
            } else {
                setBrnhBusGST({ ...GstModalObject, GSTIN: value, errorModal: true })
                if (ismodalOpen) {
                    setSuccessAndError({
                        isOpen: true,
                        id: 0,
                        title: 'Enter Valid GST Number',
                        focusId: 'bus_book_gst',
                        openNextTab: false
                    })
                }
            }
        })

    }
    useEffect(() => {
        focusElemnt('companyM')
    }, [])
    const handleBrnhBusDropDown = (val, field, valueField) => {
        setBranchBusValue({
            ...branchBusValue, [field]: val,
            [valueField[0]]: 0,
            [valueField[1]]: 0
        })
        setConfModal((prev) => ({
            ...prev,
            branchBus: true
        }))
    }
    const handleBrnhBusData = (value, field, prevValue) => {
        if (value != prevValue) {
            if (!confModal?.branchBus && isDisableBtn?.branchBus) {
                setConfModal((prev) => ({
                    ...prev,
                    branchBus: true
                }))
            }
            setBranchBusValue((prev) => ({
                ...prev,
                [field]: value === '' ? 0 : value
            }))
        }
    }

    const getBranchBusData = () => {
        setConfModal((prev) => ({
            ...prev,
            branchBus: false
        }))
        const body = {
            intUserID: 0,
            intCompanyID: loginData.intCompanyID,
            intBranchID: ModalHeaderDropDownData?.selBranch?.BranchID,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: -1
        }
        getBranchData(body).then((res) => {
            if (res.status === "Success") {
                const data = res.Data.Table[0]
                if (data?.GSTN !== '') {
                    showGstStatusModal(data?.GSTN)
                }
                selectedDefData(data)
                setIsDisableBtn((prev) => ({
                    ...prev,
                    branchBus: true
                }))
            } else {
                setSuccessAndError({
                    isOpen: true,
                    id: 0,
                    title: res?.ErrMessage,
                    focusId: 'goBtn',
                    openNextTab: false
                })
                setBranchBusValue(BranchBusObject)
                setIsDisableBtn((prev) => ({
                    ...prev,
                    branchBus: false
                }))
            }
        })
    }
    const selectedDefData = (data) => {
        let busValue = { ...branchBusValue };
        for (const key in busValue) {
            busValue[key] = data[key];
        }
        setBranchBusValue({
            ...busValue,
            BranchConOwnCity: data?.BrchBkgOwnCityCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            BranchConOwnRouter: data?.BrchBkgOwnRouteOthCityCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            BranchConOthRouter: data?.BrchBkgOthRouteCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            BranchAgentOwnCity: data?.AgentBkgOwnCityCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            BranchAgentOwnRouter: data?.AgentBkgOwnRouteOthCityCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            BranchAgentOthRouter: data?.AgentBkgOthRouteCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            ReturnBooking: data?.RefundIC_CommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            onlineAgentNon: data?.OnlineAgentNonAPICommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            onlineAgent: data?.OnlineAgentAPICommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            NonReport: data?.NonReportCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            CancellationCharge: data?.BranchCCCommPer > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            ownWay: data?.ServiceChargePct > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            return: data?.ServiceChargePctRt > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            Branchphonebkg: data?.ChargeOnPhoneBkg > 0 ? AmtAndPerOpt[0] : AmtAndPerOpt[1],
            creditLimit: data?.IsPrepaidBranch === 0 ? CreditLimitOpt[1] : CreditLimitOpt[0],
            creditLimitType: data?.IsPrepaidBranch === 1 ? CreditLimitTypeOpt[0] : data?.BranchCreditLimit > 0 ? CreditLimitTypeOpt[0] : CreditLimitTypeOpt[1],
        })
    }
    const saveBranchBusData = (isCofModal = false) => {
        if (brnhBusGST?.errorModal) {
            setSuccessAndError({
                isOpen: true,
                id: 0,
                title: 'Enter Valid GST Number',
                focusId: 'bus_book_gst',
                openNextTab: false
            })
        } else {
            const body = {
                CompanyID: loginData?.intCompanyID,
                BranchID: ModalHeaderDropDownData?.selBranch?.BranchID,
                BrchBkgOwnCityCommPer: branchBusValue?.BrchBkgOwnCityCommPer,
                BrchBkgOwnCityCommAmt: branchBusValue?.BrchBkgOwnCityCommAmt,
                BrchBkgOwnRouteOthCityCommPer: branchBusValue?.BrchBkgOwnRouteOthCityCommPer,
                BrchBkgOwnRouteOthCityCommAmt: branchBusValue?.BrchBkgOwnRouteOthCityCommAmt,
                BrchBkgOthRouteCommPer: branchBusValue?.BrchBkgOthRouteCommPer,
                BrchBkgOthRouteCommAmt: branchBusValue?.BrchBkgOthRouteCommAmt,
                AgentBkgOwnCityCommPer: branchBusValue?.AgentBkgOwnCityCommPer,
                AgentBkgOwnCityCommAmt: branchBusValue?.AgentBkgOwnCityCommAmt,
                AgentBkgOwnRouteOthCityCommPer: branchBusValue?.AgentBkgOwnRouteOthCityCommPer,
                AgentBkgOwnRouteOthCityCommAmt: branchBusValue?.AgentBkgOwnRouteOthCityCommAmt,
                AgentBkgOthRouteCommPer: branchBusValue?.AgentBkgOthRouteCommPer,
                AgentBkgOthRouteCommAmt: branchBusValue?.AgentBkgOthRouteCommAmt,
                RefundICPer: branchBusValue?.RefundIC_CommPer,
                RefundICAmt: branchBusValue?.RefundIC_CommAmt,
                OnAgNonAPIPer: branchBusValue?.OnlineAgentNonAPICommPer,
                OnAgNonAPIAmt: branchBusValue?.OnlineAgentNonAPICommAmt,
                OnAgAPIPer: branchBusValue?.OnlineAgentAPICommPer,
                OnAgAPIAmt: branchBusValue?.OnlineAgentAPICommAmt,
                nonReportCommPer: branchBusValue?.NonReportCommPer,
                nonReportCommAmt: branchBusValue?.NonReportCommAmt,
                ccPer: branchBusValue?.BranchCCCommPer,
                ccAmt: branchBusValue?.BranchCCCommAmt,
                ServiceChargePct: branchBusValue?.ServiceChargePct,
                ServiceChargePerSeat: branchBusValue?.ServiceChargePerSeat,
                ServiceChargePctRt: branchBusValue?.ServiceChargePctRt,
                ServiceChargePerSeatRt: branchBusValue?.ServiceChargePerSeatRt,
                BusGSTPct: branchBusValue?.BusTaxPct,
                HasBusCGST: branchBusValue?.BusHasCGST,
                HasBusSGST: branchBusValue?.BusHasSGST,
                HasBusIGST: branchBusValue?.BusHasIGST,
                IsPrepaidBranch: branchBusValue?.creditLimit.id === 1 ? 1 : 0,
                IsBranchCreditLimit: branchBusValue?.IsBranchCreditLimit,
                BranchCreditLimit: branchBusValue?.creditLimit?.id === 1 || branchBusValue?.creditLimitType?.id === 2 ? 0 : branchBusValue?.BranchCreditLimit,
                GSTN: branchBusValue?.GSTN,
                ChrgBranchPhnBkg: branchBusValue?.ChargeOnPhoneBkg,
                ChrgBranchPhnBkgRs: branchBusValue?.ChargeOnPhoneBkgRs
            }
            updateBranchBusData(body).then((res) => {
                if (res.status === 'Success') {
                    getBranchMaster(loginData?.intCompanyID)
                    setSuccessAndError({
                        isOpen: true,
                        id: 1,
                        title: `Branch Bus Config\nSaved Successfully!`,
                        focusId: 'goBtn',
                        openNextTab: isCofModal
                    })
                    setConfModal((prev) => ({
                        ...prev,
                        branchBus: false
                    }))
                } else {
                    setSuccessAndError({
                        isOpen: true,
                        id: 0,
                        title: res?.Message,
                        focusId: 'saveBtn',
                        openNextTab: false
                    })
                }
            })
        }
    }
    return (
        <>
            <ModalHeader
                resetAllValueBrnhMaster={() => {
                    resetAllValueBrnhMaster();
                    setResetFlag(!resetFlag)
                }}
                nextId='own_cityB' getData={getBranchBusData} loginData={loginData} />
            <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#444' }}>
                    <span style={{ color: "#1E59A7" }}>Branch Commission :</span>Confirm and Branch Confirm Booking
                </Typography>
            </Box>
            <Grid container sx={{ padding: '3px 8px' }}>
                {BranchCommissionList.map((obj, index) =>
                    obj.isDropDown ?
                        <Grid item md={obj.md}>
                            <Item >
                                <DropDownOA
                                    label={obj.label}
                                    id={obj.id}
                                    data={AmtAndPerOpt || []}
                                    defaultvalue={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    value={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    field={obj.iconsfield}
                                    tooltipTitle={obj.tooltipTitle}
                                    onSelect={(val) => {
                                        handleBrnhBusDropDown(val, [obj?.field], obj.valueField)
                                    }}
                                    dataKey={'name'}
                                    idKey={'id'}
                                    nextId={obj.nextId}
                                    prevId={obj.prevId}
                                    resetFlag={resetFlag}
                                />
                            </Item>
                        </Grid>
                        :
                        <Grid item md={obj.md}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={branchBusValue?.[obj?.field]?.id === 1 ? obj.label[0] : obj.label[1]}
                                    id={obj.id}
                                    filter={getFloat}
                                    icon="crossIcon"
                                    maxLength={branchBusValue?.[obj?.field]?.id === 1 ? 3 : 4}
                                    value={branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]]}
                                    onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 && branchBusValue?.[obj?.field]?.id === 1 ? 100 : e.target.value, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]])}
                                    onKeyDown={(e) => {
                                        navigation3(e, obj.nextId, obj.prevId, () => { })
                                    }}
                                    resetCallback={() => handleBrnhBusData(0, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], '')}
                                />
                            </Item>
                        </Grid>
                )}
            </Grid>
            <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#444 !important' }}>
                    <span style={{ color: "#1E59A7" }}>Branch Commission :</span> Offline Agent Confirm Booking
                </Typography>
            </Box>
            <Grid container sx={{ padding: '3px 8px' }}>
                {BranchCommissionAgentList.map((obj,) =>
                    obj.isDropDown ?
                        <Grid item md={obj.md}>
                            <Item >
                                <DropDownOA
                                    label={obj.label}
                                    id={obj.id}
                                    data={AmtAndPerOpt || []}
                                    defaultvalue={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    value={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    field={obj.iconsfield}
                                    tooltipTitle={obj.tooltipTitle}
                                    onSelect={(val) => {
                                        handleBrnhBusDropDown(val, [obj?.field], obj.valueField)
                                    }}
                                    dataKey={'name'}
                                    idKey={'id'}
                                    nextId={obj.nextId}
                                    prevId={obj.prevId}
                                    resetFlag={resetFlag}
                                />
                            </Item>
                        </Grid>
                        :
                        <Grid item md={obj.md}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={branchBusValue?.[obj?.field]?.id === 1 ? obj.label[0] : obj.label[1]}
                                    id={obj.id}
                                    filter={getFloat}
                                    icon={obj.iconsfield}
                                    maxLength={branchBusValue?.[obj?.field]?.id === 1 ? 3 : 4}
                                    value={branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]]}
                                    onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 && branchBusValue?.[obj?.field]?.id === 1 ? 100 : e.target.value, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]])}
                                    onKeyDown={(e) => {
                                        navigation3(e, obj.nextId, obj.prevId, () => { })
                                    }}
                                    resetCallback={() => handleBrnhBusData(0, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], '')}
                                />
                            </Item>
                        </Grid>
                )}
            </Grid>
            <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#444 !important' }}>
                    <span style={{ color: "#1E59A7" }}>Other Commission :</span> Commission on Finish Chart on Citywise
                </Typography>
            </Box>
            <Grid container sx={{ padding: '3px 8px' }}>
                {otherCommissionList.map((obj, index) =>
                    obj.isDropDown ?
                        <Grid item md={obj.md}>
                            <Item >
                                <DropDownOA
                                    label={obj.label}
                                    id={obj.id}
                                    data={AmtAndPerOpt || []}
                                    defaultvalue={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    value={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                    field={obj.iconsfield}
                                    tooltipTitle={obj.tooltipTitle}
                                    onSelect={(val) => {
                                        handleBrnhBusDropDown(val, [obj?.field], obj.valueField)
                                    }}
                                    dataKey={'name'}
                                    idKey={'id'}
                                    nextId={obj.nextId}
                                    prevId={obj.prevId}
                                    resetFlag={resetFlag}
                                />
                            </Item>
                        </Grid>
                        :
                        <Grid item md={obj.md}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={branchBusValue?.[obj?.field]?.id === 1 ? obj.label[0] : obj.label[1]}
                                    id={obj.id}
                                    filter={getFloat}
                                    icon={obj.iconsfield}
                                    maxLength={branchBusValue?.[obj?.field]?.id === 1 ? 3 : 4}
                                    value={branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]]}
                                    onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 && branchBusValue?.[obj?.field]?.id === 1 ? 100 : e.target.value, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1])}
                                    onKeyDown={(e) => {
                                        navigation3(e, obj.nextId, obj.prevId, () => { })
                                    }}
                                    resetCallback={() => handleBrnhBusData(0, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1])}
                                />
                            </Item>
                        </Grid>
                )}
                <Grid item md={4}>
                    <Item sx={{ display: 'flex' }}>
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                                <mask id="mask0_1809_33953" style={{ "mask-type": "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="19">
                                    <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_1809_33953)">
                                    <path d="M8.99976 13.25C9.21226 13.25 9.39038 13.1781 9.53413 13.0344C9.67788 12.8906 9.74975 12.7125 9.74975 12.5V9.5C9.74975 9.2875 9.67788 9.10937 9.53413 8.96562C9.39038 8.82187 9.21226 8.75 8.99976 8.75C8.78726 8.75 8.60913 8.82187 8.46538 8.96562C8.32163 9.10937 8.24976 9.2875 8.24976 9.5V12.5C8.24976 12.7125 8.32163 12.8906 8.46538 13.0344C8.60913 13.1781 8.78726 13.25 8.99976 13.25ZM8.99976 7.25C9.21226 7.25 9.39038 7.17812 9.53413 7.03437C9.67788 6.89062 9.74975 6.7125 9.74975 6.5C9.74975 6.2875 9.67788 6.10937 9.53413 5.96562C9.39038 5.82187 9.21226 5.75 8.99976 5.75C8.78726 5.75 8.60913 5.82187 8.46538 5.96562C8.32163 6.10937 8.24976 6.2875 8.24976 6.5C8.24976 6.7125 8.32163 6.89062 8.46538 7.03437C8.60913 7.17812 8.78726 7.25 8.99976 7.25ZM8.99976 17C7.96226 17 6.98726 16.8031 6.07476 16.4094C5.16226 16.0156 4.36851 15.4812 3.69351 14.8062C3.01851 14.1312 2.48413 13.3375 2.09038 12.425C1.69663 11.5125 1.49976 10.5375 1.49976 9.5C1.49976 8.4625 1.69663 7.4875 2.09038 6.575C2.48413 5.6625 3.01851 4.86875 3.69351 4.19375C4.36851 3.51875 5.16226 2.98437 6.07476 2.59062C6.98726 2.19687 7.96226 2 8.99976 2C10.0373 2 11.0123 2.19687 11.9248 2.59062C12.8373 2.98437 13.631 3.51875 14.306 4.19375C14.981 4.86875 15.5154 5.6625 15.9091 6.575C16.3029 7.4875 16.4998 8.4625 16.4998 9.5C16.4998 10.5375 16.3029 11.5125 15.9091 12.425C15.5154 13.3375 14.981 14.1312 14.306 14.8062C13.631 15.4812 12.8373 16.0156 11.9248 16.4094C11.0123 16.8031 10.0373 17 8.99976 17Z" fill="#0086FF" />
                                </g>
                            </svg>
                        </div>
                        <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#1E59A7 !important', paddingX: '5px', fontSize: '13px' }}>
                            Note : Cancellation charge commission will be credit to branch when any booking will be cancelled with cancellation charges.
                        </Typography>
                    </Item>
                </Grid>
            </Grid>
            <Grid container className='beachTransBottomSec'>
                <Grid item md={8}>
                    <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                        <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#1E59A7 !important' }}>
                            Service Charge
                        </Typography>
                    </Box>
                    <Grid container sx={{ padding: '3px 0px 3px 8px' }}>
                        {ServiceChargeList.map((obj, index) =>
                            obj.isDropDown ?
                                <Grid item md={obj.md}>
                                    <Item >
                                        <DropDownOA
                                            label={obj.label}
                                            id={obj.id}
                                            data={AmtAndPerOpt || []}
                                            defaultvalue={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                            value={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                            field={obj.iconsfield}
                                            tooltipTitle={obj.tooltipTitle}
                                            onSelect={(val) => {
                                                handleBrnhBusDropDown(val, [obj?.field], obj.valueField)
                                            }}
                                            dataKey={'name'}
                                            idKey={'id'}
                                            nextId={obj.nextId}
                                            prevId={obj.prevId}
                                            resetFlag={resetFlag}
                                        />
                                    </Item>
                                </Grid>
                                :
                                <Grid item md={obj.md}>
                                    <Item className={'input--wrapper btmSpaceNotRequired'}>
                                        <LineinputV2
                                            label={branchBusValue?.[obj?.field]?.id === 1 ? obj.label[0] : obj.label[1]}
                                            id={obj.id}
                                            filter={getFloat}
                                            icon={obj.iconsfield}
                                            maxLength={branchBusValue?.[obj?.field]?.id === 1 ? 3 : 4}
                                            value={branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]]}
                                            onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 && branchBusValue?.[obj?.field]?.id === 1 ? 100 : e.target.value, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]])}
                                            onKeyDown={(e) => {
                                                navigation3(e, obj.nextId, obj.prevId, () => { })
                                            }}
                                            resetCallback={() => handleBrnhBusData(0, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], '')}

                                        />
                                    </Item>
                                </Grid>
                        )}
                    </Grid>
                </Grid>
                <Grid item md={4}>
                    <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                        <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#1E59A7 !important' }}>
                            GST%
                        </Typography>
                    </Box>
                    <Grid container sx={{ padding: '3px 0px' }}>
                        <Grid item md={5.5}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={'GST'}
                                    id='gst'
                                    value={branchBusValue?.BusTaxPct}
                                    filter={getFloat}
                                    icon={'crossIcon'}
                                    maxLength={3}
                                    onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 ? 100 : e.target.value, 'BusTaxPct', branchBusValue?.BusTaxPct)}
                                    onKeyDown={(e) => {
                                        navigation3(e, 'CGST', 'percentageR', () => { })
                                    }}
                                    resetCallback={() => handleBrnhBusData(0, 'BusTaxPct', '')}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={2} >
                            <Item>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox id='CGST' checked={branchBusValue?.BusHasCGST === 1} sx={{ zIndex: 0 }} />}
                                    onKeyDown={(e) => {
                                        navigation3(e, "SGST", 'gst', () => { })
                                    }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            CGST
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setBranchBusValue({
                                            ...branchBusValue,
                                            BusHasCGST: e.target.checked ? 1 : 0
                                        })
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={2} >
                            <Item>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox id='SGST' checked={branchBusValue?.BusHasSGST === 1} sx={{ zIndex: 0 }} />}
                                    onKeyDown={(e) => {
                                        navigation3(e, "IGST", 'CGST', () => { })
                                    }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            SGST
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setBranchBusValue({
                                            ...branchBusValue,
                                            BusHasSGST: e.target.checked ? 1 : 0
                                        })
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                        <Grid item md={2} >
                            <Item>
                                <FormControlLabel
                                    value="end"
                                    control={<Checkbox id='IGST' checked={branchBusValue?.BusHasIGST === 1} sx={{ zIndex: 0 }} />}
                                    onKeyDown={(e) => {
                                        navigation3(e, "credit_limit", 'SGST', () => { })
                                    }}
                                    label={
                                        <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                            IGST
                                        </Typography>
                                    }
                                    onChange={(e) => {
                                        setBranchBusValue({
                                            ...branchBusValue,
                                            BusHasIGST: e.target.checked ? 1 : 0
                                        })
                                    }}
                                    labelPlacement="end"
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container className='beachTransBottomSec'>
                <Grid item md={6}>
                    <Box sx={{ paddingX: '16px', backgroundColor: '#F2F9FF' }}>
                        <FormControlLabel
                            value="end"
                            control={<Checkbox id='credit_limit' checked={branchBusValue?.IsBranchCreditLimit === 1} sx={{ padding: '2px 12px 5px 10px' }} />}
                            onKeyDown={(e) => {
                                navigation3(e, branchBusValue?.IsBranchCreditLimit === 1 ? "create_limitD" : 'bus_book_gst', 'IGST', () => { })
                            }}
                            label={
                                <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                    Credit Limit
                                </Typography>
                            }
                            onChange={(e) => {
                                setBranchBusValue({ ...branchBusValue, IsBranchCreditLimit: e.target.checked ? 1 : 0 })
                            }}
                            labelPlacement="end"
                        />
                    </Box>
                    <Grid container sx={{ padding: '3px 0px 3px 8px' }}>
                        <Grid item md={4}>
                            <Item >
                                <DropDownOA
                                    label={'Credit Limit'}
                                    data={CreditLimitOpt || []}
                                    defaultvalue={branchBusValue?.creditLimit?.name || branchBusValue?.creditLimit}
                                    value={branchBusValue?.creditLimit?.name || branchBusValue?.creditLimit}
                                    onSelect={(val) => {
                                        if (val.id === 1) {
                                            setBranchBusValue((prev) => ({
                                                ...prev,
                                                creditLimit: val,
                                                creditLimitType: CreditLimitTypeOpt[0],
                                            }))
                                        } else {
                                            setBranchBusValue((prev) => ({
                                                ...prev,
                                                creditLimit: val,
                                            }))
                                        }
                                    }}
                                    disabled={branchBusValue?.IsBranchCreditLimit === 0}
                                    id='create_limitD'
                                    dataKey={'name'}
                                    idKey={'id'}
                                    nextId={branchBusValue?.creditLimit?.id === 1 ? 'bus_book_gst' : 'credit_limit_type'}
                                    prevId={'credit_limit'}
                                    resetFlag={resetFlag}

                                />
                            </Item>
                        </Grid>
                        <Grid item md={4}>
                            <Item >
                                <DropDownOA
                                    label={'Credit Limit Type'}
                                    id='credit_limit_type'
                                    data={CreditLimitTypeOpt || []}
                                    defaultvalue={branchBusValue?.creditLimitType?.name || branchBusValue?.creditLimitType}
                                    value={branchBusValue?.creditLimitType?.name || branchBusValue?.creditLimitType}
                                    onSelect={(val) => {
                                        setBranchBusValue((prev) => ({ ...prev, creditLimitType: val }))
                                    }}
                                    disabled={branchBusValue?.IsBranchCreditLimit === 0 || branchBusValue?.creditLimit?.id === 1}
                                    dataKey={'name'}
                                    idKey={'id'}
                                    nextId={branchBusValue?.creditLimitType?.id === 2 ? 'bus_book_gst' : 'cAmount'}
                                    prevId={'create_limitD'}
                                    resetFlag={resetFlag}

                                />
                            </Item>
                        </Grid>
                        <Grid item md={4}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={'Amount'}
                                    id='cAmount'
                                    value={branchBusValue?.BranchCreditLimit}
                                    filter={getFloat}
                                    icon={'crossIcon'}
                                    disabled={branchBusValue?.IsBranchCreditLimit === 0 || branchBusValue?.creditLimit?.id === 1 || branchBusValue?.creditLimitType?.id === 2}
                                    onBlur={(e) => handleBrnhBusData(e.target.value, "BranchCreditLimit", branchBusValue?.BranchCreditLimit)}
                                    onKeyDown={(e) => {
                                        navigation3(e, "bus_book_gst", 'credit_limit_type', () => { })
                                    }}
                                    resetCallback={() => handleBrnhBusData(0, "BranchCreditLimit", '')}

                                />
                            </Item>
                        </Grid>

                    </Grid>
                </Grid>
                <Grid item md={2}>
                    <Box sx={{ padding: '5px 16px', backgroundColor: '#F2F9FF' }}>
                        <Typography variant='h6' sx={{ fontWeight: '500', lineHeight: '18px', color: '#1E59A7 !important' }}>
                            Bus Booking GSTIN
                        </Typography>
                    </Box>
                    <Grid container sx={{ padding: '3px 0px' }}>
                        <Grid item md={12}>
                            <Item className={'input--wrapper btmSpaceNotRequired'}>
                                <LineinputV2
                                    label={'GSTIN'}
                                    id='bus_book_gst'
                                    onKeyDown={(e) => {
                                        navigation3(e, "Chrg_phone_book", branchBusValue?.IsBranchCreditLimit === 1 ? branchBusValue?.creditLimit?.id === 1 ? 'create_limitD' : branchBusValue?.creditLimitType?.id === 2 ? "credit_limit_type" : "cAmount" : 'credit_limit', () => { })
                                    }}
                                    icon={'crossIcon'}
                                    value={branchBusValue?.GSTN}
                                    onBlur={(e) => {
                                        if (e.target.value != branchBusValue?.GSTN) {
                                            setBranchBusValue({ ...branchBusValue, "GSTN": e.target.value })
                                            if (e.target.value !== '') {
                                                showGstStatusModal(e.target.value, true)
                                            } else {
                                                setBrnhBusGST({ ...GstModalObject, errorModal: false })

                                            }
                                        }
                                    }}
                                    resetCallback={() => {
                                        setBranchBusValue({ ...branchBusValue, "GSTN": '' })
                                        setBrnhBusGST({ ...GstModalObject, errorModal: false })


                                    }}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={4}>
                    <Box sx={{ paddingX: '10px', backgroundColor: '#F2F9FF' }}>
                        <FormControlLabel
                            value="end"
                            control={<Checkbox id='Chrg_phone_book' checked={isChecked?.PhoneBookRupees} sx={{ padding: '5px 16px',display:'none'}} />}
                            onKeyDown={(e) => {
                                navigation3(e, isChecked?.PhoneBookRupees ? 'Branch_phone_bkg' : "cancelBtn", 'bus_book_gst', () => { })
                            }}
                            label={
                                <Typography variant='h6' sx={{ fontWeight: '500', color: '#1E59A7 !important' }}>
                                    Charges for Branch Phone Booking Rupees
                                </Typography>
                            }
                            onChange={(e) => {
                                setIsChecked({ ...isChecked, PhoneBookRupees: e.target.checked })
                            }}
                            sx={{padding:'3px 16px 2px 16px'}}
                            labelPlacement="end"
                        />
                    </Box>
                    <Grid container sx={{ padding: '3px 8px 3px 0px' }}>
                        {PhoneBookRupeesList.map((obj, index) =>
                            obj.isDropDown ?
                                <Grid item md={obj.md}>
                                    <Item >
                                        <DropDownOA
                                            label={obj.label}
                                            id={obj.id}
                                            data={AmtAndPerOpt || []}
                                            defaultvalue={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                            value={branchBusValue?.[obj?.field]?.name || branchBusValue?.[obj?.field]}
                                            field={obj.iconsfield}
                                            tooltipTitle={obj.tooltipTitle}
                                            onSelect={(val) => {
                                                handleBrnhBusDropDown(val, [obj?.field], obj.valueField)
                                            }}
                                            disabled={!isChecked?.PhoneBookRupees}
                                            dataKey={'name'}
                                            idKey={'id'}
                                            nextId={obj.nextId}
                                            prevId={obj.prevId}
                                            resetFlag={resetFlag}
                                        />
                                    </Item>
                                </Grid>
                                :
                                <Grid item md={obj.md}>
                                    <Item className={'input--wrapper btmSpaceNotRequired'}>
                                        <LineinputV2
                                            label={branchBusValue?.[obj?.field]?.id === 1 ? obj.label[0] : obj.label[1]}
                                            id={obj.id}
                                            filter={getFloat}
                                            icon={obj.iconsfield}
                                            disabled={!isChecked?.PhoneBookRupees}
                                            maxLength={branchBusValue?.[obj?.field]?.id === 1 ? 3 : 4}
                                            value={branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]]}
                                            onBlur={(e) => handleBrnhBusData(Number(e.target.value) > 100 && branchBusValue?.[obj?.field]?.id === 1 ? 100 : e.target.value, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], branchBusValue?.[obj?.field]?.id === 1 ? branchBusValue?.[obj.valueField[0]] : branchBusValue?.[obj.valueField[1]])}
                                            onKeyDown={(e) => {
                                                navigation3(e, obj.nextId, obj.prevId, () => { })
                                            }}
                                            resetCallback={(e) => handleBrnhBusData(0, branchBusValue?.[obj?.field]?.id === 1 ? obj.valueField[0] : obj.valueField[1], '')}
                                        />
                                    </Item>
                                </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'end', position: 'sticky', paddingBottom: '4px', bottom: 0, backgroundColor: '#fff', borderTop: '1px solid #A6A8AB' }} className='reportButton'>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='cancelBtn' variant="outlined" sx={{ width: '100%' }} className="receiveitembtn"
                        onKeyDown={(e) => {
                            navigation3(e, "saveBtn", isChecked?.PhoneBookRupees ? 'percentageBPB' : 'Chrg_phone_book', () => { })
                        }}
                        onClick={() => {
                            updateModal(false, mdt.createNewBranchMaster)
                        }}
                    >
                        CANCEL
                    </Button>
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper disableBtn">
                    <Button id='saveBtn' variant="contained" style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary"
                        disabled={!isDisableBtn?.branchBus}
                        onKeyDown={(e) => {
                            navigation3(e, "companyM", 'cancelBtn', () => { })
                        }}
                        onClick={saveBranchBusData}
                    >
                        Save
                    </Button>
                </Item>

            </Box>
            {gstStatusModal && <GSTStatusModal  {...gstStatusModalProps} />}
            {confModal?.branchBus && tabData?.isChgTab && <ConfirmModal title="branch Bus Config" header="Do You Want to update the Branch Bus" updateModal={() => {
                setSelectedTab(tabData?.isnextValue)
                setConfModal((prev) => ({
                    ...prev,
                    branchBus: false
                }))
                setTabData((prev) => ({
                    ...prev,
                    isChgTab: false,
                }))
            }}
                handleConfirm={() => {
                    saveBranchBusData(true)
                    setTabData((prev) => ({
                        ...prev,
                        isChgTab: false,
                    }))
                }}

            />
            }
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => {
                if (successAndError?.openNextTab && successAndError?.id === 1) {
                    setSelectedTab(tabData?.isnextValue)
                    setConfModal((prev) => ({
                        ...prev,
                        branchBus: false
                    }))
                }
                setSuccessAndError({
                    isOpen: false,
                    id: 0,
                    title: '',
                    openNextTab: false
                })
                focusElemnt(successAndError?.focusId)
            }} isError={successAndError?.id === 0} open={successAndError?.isOpen} title={successAndError?.title} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchData, updateBranchBusData, getGSTNValidation, getBranchMaster }
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(BrnhBusConfig))